import type { ReactNode } from 'react';
import './Modal.css';

interface ModalProps {
  children: ReactNode;
  footer?: ReactNode;
  onClose: () => void;
  title: string;
}

export const Modal = ({ children, footer, onClose, title }: ModalProps) => (
  <div className="modal-backdrop" onMouseDown={onClose} role="presentation">
    <section
      aria-modal="true"
      className="modal"
      onMouseDown={(event) => event.stopPropagation()}
      role="dialog"
    >
      <header className="modal-header">
        <h2>{title}</h2>
        <button aria-label="Close modal" className="modal-close" onClick={onClose} type="button">×</button>
      </header>
      <div className="modal-body">{children}</div>
      {footer && <footer className="modal-footer">{footer}</footer>}
    </section>
  </div>
);
